export enum PropertiesRequestTypes {
  GetAllPropertiesRequest = 'properties.getall.request',
  GetAllPropertiesSuccess = 'properties.getall.success',
  GetAllPropertiesFailure = 'properties.getall.failure',
  GetPropertyRequest = 'properties.get.request',
  GetPropertySuccess = 'properties.get.success',
  GetPropertyFailure = 'properties.get.failure',
  SilenceIssueRequest = 'properties.silence.request',
  SilenceIssueSuccess = 'properties.silence.success',
  SilenceIssueFailure = 'properties.silence.failure',
  UnSilenceIssueRequest = 'properties.unsilence.request',
  UnSilenceIssueSuccess = 'properties.unsilence.success',
  UnSilenceIssueFailure = 'properties.unsilence.failure',
}
